import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { AuthProvider } from "./lib/auth";
import { captureAttribution, initAnalytics, initPixel, trackPageView } from "./lib/tracking";
import { applyPageMeta } from "./lib/seo";
import Home from "./pages/Home";
import Treatments from "./pages/Treatments";
import Contact from "./pages/Contact";
import Landing from "./pages/Landing";
import Memberships from "./pages/Memberships";
import About from "./pages/About";
import Blog from "./pages/Blog";
import Article from "./pages/Article";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import Glow from "./pages/Glow";
import TreatmentPage from "./pages/TreatmentPage";
import ContactUs from "./pages/ContactUs";
import PeelQuiz from "./pages/PeelQuiz";
import BookOnline from "./pages/BookOnline";
import BookingConfirmed from "./pages/BookingConfirmed";
import { OFFERS } from "./data/offers";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    captureAttribution();
    applyPageMeta(pathname);
    if (!pathname.startsWith("/admin")) {
      initAnalytics();
      initPixel();
      trackPageView();
    }
  }, [pathname]);
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 80);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const BARE = ["/private-consultation", "/new-client-offer", "/glow"];

const Chrome = ({ children }) => {
  const { pathname } = useLocation();
  const bare = BARE.includes(pathname) || pathname.startsWith("/admin");
  return (
    <>
      {!bare && <Header />}
      {children}
      {!bare && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollManager />
          <Chrome>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/treatments" element={<Treatments />} />
              <Route path="/treatments/:slug" element={<TreatmentPage />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<Article />} />
              <Route path="/memberships" element={<Memberships />} />
              <Route path="/private-consultation" element={<Landing offer={OFFERS.consultation} />} />
              <Route path="/new-client-offer" element={<Landing offer={OFFERS.newClient} />} />
              <Route path="/glow" element={<Glow />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/which-peel-is-right-for-me" element={<PeelQuiz />} />
              <Route path="/book-online" element={<BookOnline />} />
              <Route path="/booking-confirmed" element={<BookingConfirmed />} />
              <Route path="/thankyou" element={<BookingConfirmed />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </Chrome>
        </AuthProvider>
        <Toaster position="bottom-right" toastOptions={{ className: "rounded-none" }} />
      </BrowserRouter>
    </div>
  );
}

export default App;
